export default "__VITE_ASSET__Cq7QEO2h__"